import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import unsure from '../images/unsure.gif';

const NotFound = () => {

    const [loading, setLoading] = useState(true);

    if (loading) {
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    }

    return (
        <Box sx={{ mt: 4, pb: 4 }}>
            {!loading ? (
                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h4">
                        We can't find what you're looking for...
                    </Typography>
                    <Box component="img" alt="Thinking Man" src={unsure} sx={{ mt: 5, pt: 2 }} />
                </Box>
            ) : (
                <Box sx={{ height: '300px' }} />
            )}
        </Box>
    );
}

export default NotFound;
